//hooks
import {useState} from 'react'

//component
import Login from "./Login";
import Signup from "./Signup";

//mui
import Button from '@mui/material/Button';

//translate
import { useTranslation } from 'react-i18next';

//type
interface AuthDialogProps {
    setOpenOtp: (open:boolean)=>void
}

const AuthDialog = ({setOpenOtp}: AuthDialogProps) => {
    const {t} = useTranslation()
    const [openLogin, setOpenLogin] = useState(false);
    const [openSignup, setOpenSignup] = useState(false);

    const handleOpenLogin = ()=> {
        setOpenLogin(true)
    }
    return (
            <div>
            <Button className='!bg-customerColor' color="inherit" onClick={handleOpenLogin}>
                {t("login")}
            </Button>

            <Login
                openLogin={openLogin}
                setOpenLogin={setOpenLogin}
                setOpenSignup={setOpenSignup}
            />

            <Signup
                openSignup={openSignup}
                setOpenSignup={setOpenSignup}
                setOpenOtp = {setOpenOtp}
            />
        </div>
    )
}

export default AuthDialog